import React from 'react';
import { Link } from 'react-router-dom';

export type LogoMarkProps = {
  size?: number;
  mono?: boolean;
};

export const LogoMark: React.FC<LogoMarkProps> = ({ size = 28, mono = false }) => (
  <img
    src="/logo.png"
    alt=""
    aria-hidden
    className={mono ? 'logo-img logo-img-mono' : 'logo-img'}
    style={{
      width: 'auto',
      height: size,
      display: 'block',
      objectFit: 'contain',
    }}
  />
);

export type LogoProps = {
  size?: number;
  mono?: boolean;
  to?: string;
};

export const Logo: React.FC<LogoProps> = ({ size = 32, mono = false, to = '/' }) => (
  <Link
    to={to}
    aria-label="Almaship"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: 'inherit',
    }}
  >
    <img
      src="/logo.png"
      alt="Almaship"
      className={mono ? 'logo-img logo-img-mono' : 'logo-img'}
      style={{
        width: 'auto',
        height: size * 1.15,
        display: 'block',
        objectFit: 'contain',
      }}
    />
  </Link>
);
